import { Navbar } from '@/components/layout/Navbar';
import { HeroSection } from '@/components/landing/HeroSection';
import { WorkflowVisualization } from '@/components/landing/WorkflowVisualization';
import { FeaturesSection } from '@/components/landing/FeaturesSection';
import { ProductShowcase } from '@/components/landing/ProductShowcase';
import { HowItWorksSection } from '@/components/landing/HowItWorksSection';
import { ChannelsSection } from '@/components/landing/ChannelsSection';
import { PricingSection } from '@/components/landing/PricingSection';
import { FAQSection } from '@/components/landing/FAQSection';
import { ContactSection } from '@/components/landing/ContactSection';
import { CTASection } from '@/components/landing/CTASection';
import { Footer } from '@/components/landing/Footer';
import { MouseFollower } from '@/components/landing/MouseFollower';

export function Landing() {
  return (
    <div className="min-h-screen bg-background">
      {/* Mouse Follower - Global */}
      <MouseFollower />

      {/* Content */}
      <Navbar />
      <HeroSection />
      <WorkflowVisualization />
      <FeaturesSection />
      <ProductShowcase />
      <HowItWorksSection />
      <ChannelsSection />
      <PricingSection />
      <FAQSection />
      <ContactSection />
      <CTASection />
      <Footer />
    </div>
  );
}
